import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';

class Division extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depth1: null,
      onchange: false
    };
  }

  componentWillMount() {
    const { cmAPI } = this.props;

    cmAPI.divisionChange({
      type: 'depth',
      name: 'value',
      value: null
    });
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    const { defaultValue, divisionList } = nextProps;
    const { onchange } = this.state;

    if (divisionList && defaultValue && defaultValue.length > 0 && !onchange) {
      const { division } = divisionList.data;
      this.defaultSetDivision(division);
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return true;
  // }

  divisionClick = (val, idx) => {
    const { onChangeFunc } = this.props;
    let value = val;

    if (value == 0 && idx != 1) {
      value = this.state['selValue' + (idx - 1)];
    }

    const orgCode = cm.divisionOrgIdx(value);

    try {
      const { cmAPI } = this.props;

      cmAPI.divisionChange({
        type: 'depth',
        name: 'value',
        value: value === 0 ? null : value
      });

      cmAPI.divisionChange({
        type: 'orgIdx',
        name: 'value',
        value: orgCode
      });
    } catch (e) {
      console.log('###### e : ', e);
    } finally {
      if (onChangeFunc) onChangeFunc();
    }
  };

  defaultSetDivision = async (divisions) => {
    let dataSet = [];
    let data = [];

    await this.setState({
      onchange: true
    });

    const { defaultValue } = this.props;
    defaultValue.forEach((orgCode, i) => {
      let index = 0;
      let division = divisions;
      let depth = [];

      if (defaultValue.length == i + 1) {
        const { cmAPI } = this.props;

        cmAPI.divisionChange({
          type: 'depth',
          name: 'value',
          value: orgCode
        });
      }

      if (dataSet.length > 0) {
        let temp = dataSet[i - 1];
        // 선택된 상위 부서에 하위 부서가 없으면 빈 목록으로 둔다 (상위 목록을 재사용하면 엉뚱한 부서가 매칭된다)
        const depthInfo = temp['depth' + i] || {};
        const cIdx = depthInfo.cIdx;
        const selected = (depthInfo.tempdivision || [])[cIdx - 1];
        division = selected && selected.division ? selected.division : [];
      }

      data['value'] = orgCode;
      (division || []).some((item, idx) => {
        if (item.orgCode === orgCode) {
          data['index'] = idx;

          depth.push({
            value: 0,
            text: '부서 전체'
          });

          //선택 된 부서 하위 부서가 있을 시
          if (item.division) {
            //하위 부서를 depth에 push
            item.division.map((data) => {
              depth.push({
                value: data.orgCode,
                text: data.name
              });
            });
          }
        }
      });

      this.setState({
        ['depth' + (i + 1)]: {
          depth: depth,
          cIdx: data.index + 1,
          tempdivision: division
        },
        ['selValue' + (i + 1)]: data.value
      });
      dataSet.push({
        ['depth' + (i + 1)]: {
          depth: depth,
          cIdx: data.index + 1,
          tempdivision: division
        },
        ['selValue' + (i + 1)]: data.value
      });
    });
  };

  divisionDepth = async (event, data, division, idx) => {
    const { staffDivisionList } = this.props;
    const allDepth = staffDivisionList && staffDivisionList.data ? staffDivisionList.data.depth : null;
    let totalDepth = allDepth || storage.get('depth');

    //현재 부서의 하위 부서를 모두 삭제
    for (let i = idx; i <= totalDepth; i++) {
      if (this.state['depth' + i]) {
        delete this.state['depth' + i];
        delete this.state['selValue' + i];
      }
    }

    let depth = [];

    //선택 된 부서 위치 index
    let c = null;

    if (!event) {
      c = data.index;
    } else {
      c =
        $(event.target).prop('tagName') !== 'SPAN'
          ? $(event.target).index()
          : $(event.target)
              .parent()
              .index();
      c = c === 0 ? 1 : c;
    }

    //현재 선택 된 부서 depth
    let tempdivision = division;

    //첫 depth가 아닐 때
    if (idx !== 1) {
      // 현재 부서 하위 depth
      tempdivision = division.division;
    }

    (tempdivision || []).some((item, idx) => {
      if (item.orgCode === data.value) {
        //default
        depth.push({
          value: 0,
          text: '부서 전체'
        });

        //선택 된 부서 하위 부서가 있을 시
        if (item.division) {
          //하위 부서를 depth에 push
          item.division.map((data) => {
            depth.push({
              value: data.orgCode,
              text: data.name
            });
          });
        }

        return;
      }
    });

    await this.setState({
      ['depth' + idx]: {
        depth: depth,
        cIdx: c,
        tempdivision: tempdivision
      },
      ['selValue' + idx]: data.value
    });
    this.divisionClick(data.value, idx);
  };

  divisionForm = (division, inputStyle) => {
    const { defaultValue, isDim, isSearch, placeholderText, staffDivisionList } = this.props;
    const allDepth = staffDivisionList && staffDivisionList.data ? staffDivisionList.data.depth : null;
    let totalDepth = allDepth || storage.get('depth');
    let form = [];
    const depth = [];
    const temp = [];

    for (let i = 0; i < totalDepth; i++) {
      const defaultOptions = { value: 0, text: placeholderText ? placeholderText : '부서 ' + (i + 1) };

      let isShow = false;
      let cIdx = 0;
      let tempdivision = null;
      let lowDepth = this.state['depth' + i];
      let selValue = this.state['selValue' + i] ? this.state['selValue' + i] : 0;

      if (i === 0) {
        depth.push(defaultOptions);

        //depth 1 데이터
        division.map((data) => {
          depth.push({
            value: data.orgCode,
            text: data.name
          });
        });
        isShow = true;
      } else {
        // 상위 depth 데이터가 있을 시
        if (lowDepth) {
          // 선택한 부서의 index
          cIdx = this.state['depth' + i].cIdx - 1;
          // 현재 부서
          tempdivision = lowDepth.tempdivision;
          //하위 부서가 있을 시
          if (lowDepth.depth.length > 1) {
            isShow = true;
          } else {
            lowDepth = {
              depth: [defaultOptions]
            };
          }

          // 상위 depth가 선택 되지 않았을 때 default depth;
        } else {
          lowDepth = {
            depth: [defaultOptions]
          };
        }
      }
      form.push(
        <Dropdown
          className="division-selectbox"
          key={i}
          placeholder={placeholderText ? placeholderText : '부서 ' + (i + 1)}
          search={isSearch}
          style={inputStyle}
          options={lowDepth ? lowDepth.depth : depth}
          value={this.state['selValue' + (i + 1)] ? this.state['selValue' + (i + 1)] : 0}
          disabled={!isShow || isDim}
          onChange={
            lowDepth
              ? (event, data) => this.divisionDepth(event, data, tempdivision[cIdx], i + 1)
              : (event, data) => this.divisionDepth(event, data, division, i + 1)
          }
          selection
        />
      );
    }

    return form;
  };

  render() {
    const depth1 = [],
      { staffDivisionList, divisionList, label, inputStyle, style, isLabel, placeholderText } = this.props,
      defaultOptions = [{ value: 0, text: placeholderText ? placeholderText : '부서 1' }];
    // { depth2, depth3 }  = this.state;

    let def = 0;
    let divisionForm = null;
    let staffDivisionForm = null;

    if (staffDivisionList) {
      const { division } = staffDivisionList.data;
      staffDivisionForm = this.divisionForm(division, inputStyle);
    } else if (divisionList) {
      const { division } = divisionList.data;
      divisionForm = this.divisionForm(division, inputStyle);
    }

    return (
      <div>
        {staffDivisionList ? (
          <Form.Field inline style={style} className="com-selectbox">
            {isLabel ? <label style={label}>부서1 *</label> : null}
            {staffDivisionList ? (
              staffDivisionForm
            ) : (
              <Dropdown
                placeholder={placeholderText ? placeholderText : '부서 1'}
                style={inputStyle}
                selection
                disabled
                defaultValue={0}
                key={0}
                options={defaultOptions}
              />
            )}
          </Form.Field>
        ) : (
          <Form.Field inline style={style} className="com-selectbox">
            {isLabel ? <label style={label}>부서1 *</label> : null}
            {divisionList ? (
              divisionForm
            ) : (
              <Dropdown
                placeholder={placeholderText ? placeholderText : '부서 1'}
                style={inputStyle}
                selection
                disabled
                defaultValue={0}
                key={0}
                options={defaultOptions}
              />
            )}
          </Form.Field>
        )}
      </div>
    );
  }
}

Division = connect(
  (state) => ({
    depth: state.commons.depth,
    divisionList: state.commons.division
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        divisionChange: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(Division);

export default Division;
